import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Link } from "react-router-dom";
import LogoKrause from "../../assets/logo/logo-grupo-krause-branco.png";
import Facebook from "../../assets/icons/facebook.svg";
import Instagram from "../../assets/icons/instagram.svg";
import Linkedin from "../../assets/icons/linkedin.svg";
import Youtube from "../../assets/icons/youtube.svg";
import LGPD from "../../assets/logo/lgpd.png";
import Google from "../../assets/logo/google.png";
import SSL from "../../assets/logo/ssl.png";
import "./Footer.css";

function Footer(props) {
  return (
    <div>
      <Container fluid className="footer-bottom-section">
        <Container>
          <Row>
            <Col md={3} className="footer-logo-col">
              <Link to="/">
                <img
                  src={LogoKrause}
                  alt="Logo Grupo Krause"
                  className="footer-logo"
                />
              </Link>
              <div className="footer-icon-links">
                <a
                  href="https://www.facebook.com/grupokrauseoficial/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={Facebook}
                    alt="icone facebook"
                    className="footer-social-links"
                  />
                </a>
                <a
                  href="https://www.instagram.com/grupokrause/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={Instagram}
                    alt="icone instagram"
                    className="footer-social-links"
                  />
                </a>
                <a
                  href="https://br.linkedin.com/company/grupokrause"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={Linkedin}
                    alt="icone Linkedin"
                    className="footer-social-links"
                  />
                </a>
                <a
                  href="https://www.youtube.com/channel/UCe25r6x82-9ASERj8IkU-vw"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={Youtube}
                    alt="icone youtube"
                    className="footer-social-links"
                  />
                </a>
              </div>
            </Col>
            <Col md={3} className="footer-links">
              <a
                href="https://centraldocliente.grupokrause.com.br/login?redirect=/boletos"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: props.white }}
              >
                Central do Cliente
              </a>
              <Link style={{ color: props.white }} to="/quem-somos/">
                O Grupo Krause
              </Link>
              <Link style={{ color: props.white }} to="/destaques/">
                Destaques
              </Link>
              <Link style={{ color: props.white }} to="/onde-estamos/">
                Onde Estamos
              </Link>
              <Link style={{ color: props.white }} to="/trabalhe-conosco/">
                Trabalhe Conosco
              </Link>
              <Link style={{ color: props.white }} to="/contato/">
                Contato
              </Link>
              <Link style={{ color: props.white }} to="/funeral-a-distancia/">
                Funeral a distancia
              </Link>
            </Col>
            <Col md={3} className="footer-links">
              <Link
                style={{ color: props.white }}
                to="/servicos/funeraria-krause/"
              >
                Funerária Krause
              </Link>
              <Link
                style={{ color: props.white }}
                to="/servicos/krause-assistencial/"
              >
                Krause Assistencial
              </Link>
              <Link
                style={{ color: props.white }}
                to="/servicos/memorial-krause/"
              >
                Memorial Krause
              </Link>
              <Link style={{ color: props.white }} to="/servicos/mais-que-pet/">
                Mais Que Pet
              </Link>
              <Link
                style={{ color: props.white }}
                to="/servicos/pequenos-cometas/"
              >
                Pequenos Cometas
              </Link>
              <Link style={{ color: props.white }} to="/estrelinhas/">
                Estrelinhas Pet
              </Link>
              <Link style={{ color: props.white }} to="/velas-virtuais/">
                Velas Virtuais
              </Link>
            </Col>
            <Col md={3} className="footer-links">
              <Link style={{ color: props.white }} to="/privacidade/">
                Privacidade e Cookies
              </Link>
              <a
                href="https://contatoseguro.com.br/grupo-krause"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: props.white }}
              >
                Canal de Denúncias
              </a>
              <a
                href="https://www.planalto.gov.br/ccivil_03/_ato2015-2018/2018/lei/l13709.htm"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={LGPD} alt="icone lgpd" className="footer-img-links" />
              </a>
              <a
                href="https://transparencyreport.google.com/safe-browsing/search?url=grupokrause.com.br&hl=pt_BR"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={Google}
                  alt="icone google"
                  className="footer-img-links"
                />
              </a>
              <a
                href="https://www.ssllabs.com/ssltest/analyze.html?d=grupokrause.com.br"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={SSL} alt="icone ssl" className="footer-img-links" />
              </a>
            </Col>
          </Row>
          <Row className="footer-contact-row">
            <Col md={4} className="footer-contact-col">
              <a
                style={{ color: props.white }}
                href={`https://wa.me/${props.whatsAppNumber}`}
                rel="noopener noreferrer"
                className="footer-contact-link"
              >
                <p>WhatsApp</p> <span>{props.whatsAppText}</span>
              </a>
            </Col>
            <Col md={4} className="footer-contact-col">
              <a
                style={{ color: props.white }}
                href="tel:05130369660"
                rel="noopener noreferrer"
                className="footer-contact-link"
              >
                <p>Atendimento 24h</p>
                <span>51 3036 9660</span>
              </a>
            </Col>
            <Col md={4} className="footer-contact-col">
              <a
                style={{ color: props.white }}
                href="tel:08000029600"
                rel="noopener noreferrer"
                className="footer-contact-link"
              >
                <p>Atendimento Funerário 24h</p>
                <span>0800 002 9600</span>
              </a>
            </Col>
          </Row>
          <Row>
            <Col style={{ color: props.white }} className="footer-rights-col">
              <p>Grupo Krause - Todos os direitos reservados - 2025</p>
            </Col>
          </Row>
        </Container>
      </Container>
    </div>
  );
}

export default Footer;
